export default "__VITE_ASSET__CYAVnk1T__"